import * as React from "react";
import { Text, View } from "react-native";
import { Link, useGlobalSearchParams, useLocalSearchParams } from "expo-router";
import { MailIcon } from "lucide-react-native";

import { PageMeta } from "~/components/PageMeta";
// import AppleLogo from "~/assets/apple-logo.svg";
import GithubLogo from "~/assets/github-logo.svg";
import GoogleLogo from "~/assets/google-logo.svg";
import Logo from "~/assets/logo-full.svg";
import { supabaseClient } from "~/lib/supabase";
import { Button } from "~/ui/Button";

export default function Login() {
  return <LoginInternal />;
}

async function signInWithGithub() {
  const { data, error } = await supabaseClient.auth.signInWithOAuth({
    provider: "github",
  });
  console.log({ data, error });
}

async function signInWithGoogle() {
  const { data, error } = await supabaseClient.auth.signInWithOAuth({
    provider: "google",
  });
  console.log({ data, error });
}

function LoginInternal() {
  const params = useLocalSearchParams();
  // const sp = useSupabaseClient();
  // const { replace } = useRouter();
  // useEffect(() => {
  //   if (window?.location?.search) {
  //     const searchParams = new URLSearchParams(window.location.search);
  //     const token = searchParams.get("token_hash");
  //     if (token) {
  //       sp.auth
  //         .verifyOtp({ token_hash: token, type: "magiclink" })
  //         .then((response) => {
  //           if (response.error) {
  //             alert(response.error.message);
  //           } else {
  //             replace("/");
  //           }
  //         })
  //         .catch((e) => console.error(e));
  //     }
  //   }
  // }, []);
  return (
    <>
      {/* <Stack.Screen
        options={{
          headerTitle: "",
          headerBackTitleVisible: false,
          headerShadowVisible: false,
        }}
      /> */}
      <PageMeta title="Login" />
      <View className="container mb-32 max-w-96 flex-grow items-stretch justify-center gap-10 p-6">
        <View className="items-center space-y-6">
          <Logo />
          <Text className="text-text-primary text-28 font-semibold">
            Welcome back
          </Text>
        </View>
        <View className="gap-6">
          <View className="flex-col gap-4">
            {/* <Button
              variant="secondary"
              componentBefore={<AppleLogo width={24} height={24} />}
            >
              Continue with Apple
            </Button> */}

            <Button
              variant="secondary"
              componentBefore={<GoogleLogo width={24} height={24} />}
              onPress={signInWithGoogle}
            >
              Continue with Google
            </Button>

            <Button
              variant="secondary"
              componentBefore={
                <Text className="text-button-label">
                  <GithubLogo width={24} height={24} />
                </Text>
              }
              onPress={signInWithGithub}
            >
              Continue with Github
            </Button>
            {params.error === "access_denied" && (
              <Text className="text-red-500">
                No account found for this provider. Please try logging in with
                email.
              </Text>
            )}
          </View>

          <View className="flex-row items-center gap-4">
            <View className="bg-divider-strong h-px grow" />
            <Text className="text-text-tertiary text-center">or</Text>
            <View className="bg-divider-strong h-px grow" />
          </View>

          <Link asChild href="/auth/login-with-email">
            <Button iconBefore={<MailIcon size={24} />}>
              Continue with email
            </Button>
          </Link>
        </View>
      </View>
    </>
  );
}
